var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tags"},_vm._l((_vm.data),function(tag){return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: _vm.getTagDescription(tag),
      classes: ['info']
    }),expression:"{\n      content: getTagDescription(tag),\n      classes: ['info']\n    }"}],key:tag.id,staticClass:"tag"},[_c('a',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.copyTagDesc(tag.description)}}},[_vm._v(_vm._s(tag.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }